import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';
import yelpLogo from '../../../assets/images/yelp-ratings/yelp_fullcolor_outline@2x.png';

class YelpRating extends Component {
  constructor(props) {
    super(props);

    this.updateFromProps = this.updateFromProps.bind(this);
    this.updateFromProps(props);
  }

  componentWillReceiveProps(nextProps) {
    this.updateFromProps(nextProps);
  }

  updateFromProps(props) {
    try {
      const roundedToHalf = Math.round(props.rating * 2) / 2;
      // eslint-disable-next-line global-require,import/no-dynamic-require
      this.imageRating = require(`../../../assets/images/yelp-ratings/yelp-${roundedToHalf}.png`);
      this.yelpUrl = `https://www.yelp.com/biz/${props.yelpId}`;
    } catch (e) {
      // do nothing
    }
  }

  /**
    if you want to link to yelp business page

    <a target="_blank" href={this.yelpUrl} >
      <img className={this.props.class} src={this.imageRating} />&nbsp;
      <img className={this.props.class} src={this.yelpLogo} />
    </a>
  */

  render() {
    const className = classnames('c-yelp-rating', this.props.className);

    if (this.props.rating === 0) {
      return null;
    }

    return (
      <div className={className}>
        <img src={this.imageRating} alt="" />&nbsp;
        <img src={yelpLogo} alt="" />
      </div>
    );
  }
}
YelpRating.propTypes = {
  rating: PropTypes.number,
  className: PropTypes.string,
};
YelpRating.defaultProps = {
  rating: null,
  className: '',
};

export default YelpRating;



// WEBPACK FOOTER //
// ./src/app/components/YelpRating.jsx